var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2706 11.4526L14.3262 10.3902C14.4911 10.2242 14.7781 10.3404 14.7781 10.5795V15.4065C14.7781 16.2862 14.0689 17 13.1947 17H1.58337C0.709217 17 0 16.2862 0 15.4065V3.72069C0 2.84094 0.709217 2.12718 1.58337 2.12718H10.6053C10.8395 2.12718 10.9582 2.41268 10.7933 2.58199L9.73771 3.64434C9.68823 3.69414 9.62226 3.72069 9.54969 3.72069H1.58337V15.4065H13.1947V11.6385C13.1947 11.5688 13.2211 11.5024 13.2706 11.4526ZM18.4363 4.75316L9.774 13.471L6.79199 13.803C5.92773 13.8993 5.19213 13.1656 5.28779 12.2892L5.61766 9.28804L14.28 0.57018C15.0354 -0.19006 16.2559 -0.19006 17.008 0.57018L18.433 2.00434C19.1884 2.76459 19.1884 3.99624 18.4363 4.75316ZM15.1772 5.77899L13.2607 3.85017L7.13175 10.0217L6.89095 12.1896L9.04499 11.9472L15.1772 5.77899ZM17.3148 3.13309L15.8898 1.69892C15.7545 1.56281 15.5335 1.56281 15.4015 1.69892L14.3823 2.72475L16.2988 4.65357L17.3181 3.62774C17.45 3.48831 17.45 3.2692 17.3148 3.13309Z",
    fill: "#727D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.ff6ba6e803051b9da7e44865727c043e.svg";
export { ForwardRef as ReactComponent };